import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import AppBar from 'material-ui/AppBar';
import Tabs, { Tab } from 'material-ui/Tabs';
import Typography from 'material-ui/Typography';
import newState from './state'//存放的数据
import {observer} from 'mobx-react'
import {withRouter } from 'react-router';
import ImageAvatars from './avatar'
function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}
TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    backgroundColor: theme.palette.background.paper,
  },
});
 @observer
class ScrollableTabsButtonAuto extends React.Component {
  state = {
    value: newState.defaultPathIndex,
  };

  handleChange = (event, value) => {//将state改变且做路由
    this.setState({ value });
    if(value!==this.state.value)this.props.history.push(newState.navigatorData[value].path)
  };
  render() {
    const { value } = this.state;
    const Tablist=newState.navigatorData.map((item,index)=>{
      return (<Tab label={item.value} key={index.toString()} />)
    })
    return (
      <div className="App-header">
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            scrollable
            scrollButtons="auto"
          >{Tablist}
          </Tabs>
          <ImageAvatars />
        </AppBar>
      </div>
    );
  }
}

ScrollableTabsButtonAuto.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(ScrollableTabsButtonAuto));


// WEBPACK FOOTER //
// ./src/navigator.js